import { SearchIcon } from "@heroicons/react/outline";
import Input from "components/input";
import { Label } from "components/label";
import Button from "components/button";
import Select from "components/select";

export interface FilterType {
  page: number;
  q: string;
  is_active: string;
}

export const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

interface PropType {
  filter: FilterType;
  handleChangeFilter: (key: string, value: string) => void;
  onSubmit: (data: FilterType) => void;
}

const FilterBar = (props: PropType) => {
  const { filter, handleChangeFilter, onSubmit } = props;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(filter);
  };

  return (
    <form
      className="box-container w-full flex flex-wrap items-end gap-3"
      onSubmit={(e) => {
        handleSubmit(e);
      }}
    >
      <div className="w-full md:w-[500px]">
        <Label id="name" name="Name" />
        <div className="mt-2">
          <Input
            className="px-2 py-2"
            label="Search"
            id="name"
            type="text"
            placeholder="Search by Club Name"
            value={filter.q}
            onChange={(e: any) => {
              handleChangeFilter("q", e.target.value);
            }}
          />
        </div>
      </div>

      <div className="w-[200px]">
        <Label id="status" name="Status" />
        <div className="mt-2">
          <Select
            options={STATUS_OPTIONS}
            isClearable={true}
            id="status"
            placeholder="Select Status"
            className="py-0.5"
            value={STATUS_OPTIONS.find((d) => d.value === filter.is_active)}
            onChange={(selected: { label: string; value: string }) => {
              handleChangeFilter("is_active", selected?.value ?? "");
            }}
          />
        </div>
      </div>

      <Button
        type="submit"
        className="w-[100px] bg-white rounded-md px-3 text-brand-500 py-2
                        border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
      >
        <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
      </Button>
    </form>
  );
};

export default FilterBar;
